<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-users text-primary mr-2"></i>
                    Gestión de Tipos de Incidencias de Consulta
                </h4>
            </b-col>
        </b-row>

        <b-row v-if="mixinCheckPermissions(['QUERY_ISSUE_TYPE_EDIT', 'QUERY_ISSUE_TYPE_NEW'])">
            <b-card-body md="12" class="bg-white">
                <b-form @submit.prevent="" class="form-inline align-text-top">

                    <b-col md="6">
                        <b-form-group>
                            <b-form-input
                                class="w-100"
                                type="text"
                                id="description"
                                v-model="queryIssueTypeItem.description"
                                placeholder="Añadir nuevo tipo de incidencia de consulta"
                                :required="true">
                            </b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col md="2">
                        Activo
                        <toggle-button
                            color="#025542"
                            :sync="true"
                            v-model="queryIssueTypeItem.active"
                            :labels="{checked: 'Si', unchecked: 'No'}"/>
                    </b-col>

                    <b-col md="1">
                        <b-button
                            @click="saveQueryIssueType"
                            type="submit"
                            variant="primary"
                            class="px-4 btn btn-pill float-right">

                            <template v-if="queryIssueTypeItem.uuid">Actualizar</template>
                            <template v-else-if="mixinCheckPermission('QUERY_ISSUE_TYPE_NEW')">Añadir</template>

                        </b-button>
                    </b-col>

                    <b-col md="1" class="ml-2">
                        <b-button
                            @click="cleanQueryIssueTypeItem"
                            variant="primary"
                            class="px-4 btn btn-pill float-right">
                            Limpiar
                        </b-button>
                    </b-col>

                </b-form>
            </b-card-body>
        </b-row>

        <b-row class="py-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Listado
                    <export-actions :rows="getQueryIssueTypesFilteredData()"></export-actions>
                </b-row>
                <v-client-table
                    ref="QueryIssueTypeTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="queryIssueTypes"
                    :options="options"
                    :theme="theme">

                    <template slot="uuid" slot-scope="props">
                        <a
                            v-if="mixinCheckPermission('QUERY_ISSUE_TYPE_EDIT')"
                            href="#"
                            @click.prevent="selectQueryIssueType(props.row)"><i class="fa fa-pencil"></i></a>
                        &nbsp;
                        <a
                            v-if="mixinCheckPermission('QUERY_ISSUE_TYPE_DELETE')"
                            href="#"
                            @click.prevent="deleteQueryIssueType(props.row.uuid)"><i class="fa fa-remove"></i></a>
                    </template>

                    <template slot="date" slot-scope="props">
                        {{props.row.date | dateFormat('DD/MM/YYYY')}}
                    </template>

                    <template slot="active" slot-scope="props">
                        <template v-if="props.row.active">Si</template>
                        <template v-else>No</template>
                    </template>
                </v-client-table>

            </b-card>
        </b-row>

    </div>
</template>

<script>

    import Vue from 'vue';
    import form from '@/helpers/form';
    import {ClientTable} from 'vue-tables-2';
    import ExportActions from '@/components/ExportActions';
    import VueNotifications from 'vue-notifications';
    import {
        getQueryIssueTypes,
        createQueryIssueType,
        updateQueryIssueType,
        deleteQueryIssueType
    } from '@/api/query-issue-type-api';

    Vue.use(ClientTable);

    export default {
        name: 'list-query-issue-types',
        components: {
            ExportActions
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                ],
                columns: ['uuid', 'username', 'date', 'description', 'active'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        username: 'Usuario',
                        date: 'Fecha',
                        description: 'Descripción',
                        active: 'Activo',

                    },
                    columnsClasses: {
                        uuid: "fit"
                    },
                    sortable: ['username', 'date', 'description', 'active'],
                    filterable: ['username', 'description'],
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    texts: null,
                    pagination: {
                        chunk: 10,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
                queryIssueTypes: [],
                queryIssueTypeItem: {
                    uuid: null,
                    description: null,
                    active: true
                }
            }
        },
        mounted() {
            this.options.texts = form.tableLabels();
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getQueryAnswerTypes();
        },
        methods: {

            async getQueryAnswerTypes() {

                this.$_loadingMixin_showLoading();

                await getQueryIssueTypes()
                    .then((queryIssueTypes) => {
                        this.queryIssueTypes = queryIssueTypes;
                    });

                this.$_loadingMixin_hideLoading();
            },

            getQueryIssueTypesFilteredData() {
                if (!!this.$refs.QueryIssueTypeTable) {
                    return this.$refs.QueryIssueTypeTable.allFilteredData.map(queryIssueType => ({
                        'Usuario': queryIssueType.username,
                        'Fecha': new Date(queryIssueType.date).toLocaleDateString(),
                        'Descripción': queryIssueType.description,
                        'Activo': queryIssueType.active ? "Si" : "No",
                    }));
                } else {
                    return [];
                }
            },

            selectQueryIssueType(selectedQueryIssueType) {
                this.queryIssueTypeItem = JSON.parse(JSON.stringify(selectedQueryIssueType));
                window.scrollTo(0, 0);
            },

            async saveQueryIssueType() {

                this.$_loadingMixin_showLoading();

                if (this.queryIssueTypeItem.uuid) {

                    await updateQueryIssueType(this.queryIssueTypeItem)
                        .then((data) => {
                            this.getQueryAnswerTypes();
                            this.cleanQueryIssueTypeItem();
                        })
                        .catch((error) => {
                            this.showErrorWhenNotSaveData();
                        });

                } else {

                    await createQueryIssueType(this.queryIssueTypeItem)
                        .then((data) => {
                            this.getQueryAnswerTypes();
                            this.cleanQueryIssueTypeItem();
                        })
                        .catch((error) => {
                            this.showErrorWhenNotSaveData();
                        });

                }

                this.$_loadingMixin_hideLoading();
            },

            async deleteQueryIssueType(queryIssueTypeId) {

                swal({
                    title: '¿Estás seguro de eliminar el tipo seleccionado?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sí, elimínalo!'
                }).then((result) => {
                    if (result.value) {

                        this.$_loadingMixin_showLoading();

                        deleteQueryIssueType(queryIssueTypeId)
                            .then((data) => {
                                this.getQueryAnswerTypes();
                            })
                            .catch((error) => {
                                this.showErrorWhenNotSaveData();
                            });

                        this.$_loadingMixin_hideLoading();

                    }
                });
            },

            cleanQueryIssueTypeItem() {
                this.queryIssueTypeItem = {
                    uuid: null,
                    description: null,
                    active: true
                }
            },

            showErrorWhenNotSaveData() {
                VueNotifications.error({
                    title: 'Error al guardar',
                    message: 'Se ha producido algún error y no hemos podido guardar los datos'
                });
            },
        }
    }
</script>